import { createMetaManager, defaultConfig } from 'vue-meta'
export default createMetaManager(false, {
  ...defaultConfig,
  meta: { tag: 'meta', nameless: true },
})